import { useState } from 'react'

// Набор реакций (синхронизирован с REACTIONS на лиц-сервере, alarms_api.py).
export const REACTIONS: { key: string; emoji: string; title: string }[] = [
  { key: 'like', emoji: '👍', title: 'Полезно' },
  { key: 'fire', emoji: '🔥', title: 'Огонь' },
  { key: 'party', emoji: '🎉', title: 'Класс' },
  { key: 'heart', emoji: '❤️', title: 'Любим' },
  { key: 'thanks', emoji: '🙏', title: 'Спасибо' },
  { key: 'bug', emoji: '🐛', title: 'Всё ещё баг' },
]

interface ReactionBarProps {
  alarmId: number
  reactions?: Record<string, number>
  myReaction?: string
  /** Только показ счётчиков, без возможности кликать (админка / тост). */
  readOnly?: boolean
  /** Компактный размер (для тоста). */
  compact?: boolean
  className?: string
}

/**
 * Ряд эмодзи-реакций со счётчиками. Клик ставит/снимает реакцию через
 * /api/alarms/react (оптимистичное обновление по ответу сервера).
 * В readOnly показывает только реакции с count > 0.
 */
export function ReactionBar({ alarmId, reactions, myReaction, readOnly, compact, className }: ReactionBarProps) {
  const [counts, setCounts] = useState<Record<string, number>>(reactions || {})
  const [mine, setMine] = useState<string>(myReaction || '')
  const [busy, setBusy] = useState(false)

  const react = async (key: string) => {
    if (readOnly || busy) return
    setBusy(true)
    try {
      const r = await fetch('/api/alarms/react', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ alarm_id: alarmId, reaction: key }),
      }).then(res => res.json())
      if (r && r.reactions) {
        setCounts(r.reactions)
        setMine(r.my_reaction || '')
      }
    } catch { /* noop */ }
    setBusy(false)
  }

  const sz = compact ? 'text-xs px-1.5 py-0.5' : 'text-xs px-2 py-1'
  const emojiSz = compact ? 'text-[13px]' : 'text-sm'

  const visible = readOnly ? REACTIONS.filter(r => (counts[r.key] || 0) > 0) : REACTIONS
  if (readOnly && visible.length === 0) return null

  return (
    <div className={`flex items-center gap-1 flex-wrap ${className || ''}`}>
      {visible.map(r => {
        const n = counts[r.key] || 0
        const active = mine === r.key
        return (
          <button
            key={r.key}
            type="button"
            disabled={!!readOnly || busy}
            title={r.title}
            onClick={(e) => { e.stopPropagation(); react(r.key) }}
            className={`inline-flex items-center gap-1 rounded-full border ${sz} leading-none transition-colors ${
              active
                ? 'border-primary/50 bg-primary/15 text-foreground'
                : 'border-border bg-muted/30 text-muted-foreground hover:border-primary/30 hover:text-foreground'
            } ${readOnly ? 'cursor-default' : 'cursor-pointer'}`}
          >
            <span className={emojiSz}>{r.emoji}</span>
            {n > 0 && <span className="tabular-nums">{n}</span>}
          </button>
        )
      })}
    </div>
  )
}
